import useSWR from 'swr'
import { GetMetadataFetcher, GetStaticMetaFile } from './MetadataFetchers'

export enum MetadataServicePath {
  GetMetadata = '/country?includeCity=true&includeDistrict=true',
}

export default {
  getStaticMetaFile: () =>
    useSWR(MetadataServicePath.GetMetadata, GetStaticMetaFile, {
      revalidateOnMount: true,
    }),
  getMetadata: () =>
    useSWR(MetadataServicePath.GetMetadata, GetMetadataFetcher, {
      revalidateOnMount: true,
    }),
}
